import { AxiosResponse } from 'axios'
import lodash from 'lodash'
import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useForm } from 'react-final-form'
import { toast } from 'react-toastify'

import Address from '../../../../../1stlog-ui/src/components/Address'
import Field, { useField } from '../../../../../1stlog-ui/src/components/Field'
import TypeAhead from '../../../../../1stlog-ui/src/components/TypeAhead'
import { request } from '../../../../../1stlog-ui/src/utils'
import useReturnApp from '../../useReturnApp'

const ShipmentSearch = (): React.ReactElement => {
  const form = useForm()

  const {
    receiver: { shortcode },
  } = useReturnApp()

  const addressCanBeEdited = useField('addressCanBeEdited')
  const isLabelActivated = useField('isLabelActivated')

  const requestOptions = async (searchBy, value): Promise<Array<object>> => {
    try {
      const { data } = (await request({
        method: 'post',
        url: '/return/lookup',
        data: {
          barcode1: value,
          short: shortcode,
        },
      })) as AxiosResponse<any>

      return lodash.map(data, (option) => ({
        barcode1: option.barcode1,
        name1: option.receiverName1,
        name2: option.receiverName2,
        name3: option.receiverName3,
        street: option.receiverStreet,
        streetNumber: option.receiverStreetNumber,
        streetNumberAddition: option.receiverStreetNumberAddition,
        zip: option.receiverZip,
        city: option.receiverCity,
        country: option.receiverCountry,
      }))
    } catch (err) {
      return []
    }
  }

  const setValues = (values): void => {
    form.batch(() => {
      form.change('pickup.address', values)
      form.change('shipmentSearch', '')
    })
    toast.success(
      i18n.t(
        'return_shipment_search_applied',
        'Adresse der Sendung wurde in das Formular übernommen.',
      ),
    )
  }

  const renderOption = (option): React.ReactElement => {
    return (
      <div>
        <h6 className="mt-0 mb-1">{option.barcode1}</h6>
        <Address {...option} />
      </div>
    )
  }

  if (isLabelActivated && !addressCanBeEdited) {
    return <></>
  }

  return (
    <Field
      name="shipmentSearch"
      // label={i18n.t('shipmentnumber', 'Sendungsnummer')}
      label={
        <div>
          {i18n.t('shipmentnumber', 'Sendungsnummer')}{' '}
          <small>({i18n.t('optional', 'optional')})</small>
        </div>
      }
    >
      <TypeAhead
        minLength={8}
        onSetValues={setValues}
        renderOption={renderOption}
        requestOptions={requestOptions}
        placeholder={i18n.t(
          'infotext_shipmentnumber_search',
          'Suchen Sie hier optional nach einer Sendungsnummer, um die Adresse zu übernehmen',
        )}
      />
    </Field>
  )
}

export default ShipmentSearch
